// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1Irdo","range":"MonthRangeSwitch_range__ANlOX","disabled":"MonthRangeSwitch_disabled__1dzgy"};